import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import ChildRow from "./ChildRow";
import ButtonIcon from "../../../components/ButtonIcon/ButtonIcon";
import style from "../Application.module.scss";
import DropDown from "../../../components/DropDown/DropDown";
import AppStatusDot from "./AppStatusDot/AppStatusDot";
import Checkbox from "../../../components/Checkbox/Index";
import { dateFormatter } from "../../../../components/helper/helper";
import AssignProcessor from "./AssignProcessor/AssignProcessor";
import ChangeOwner from "./ChangeOwner/ChangeOwner";
import CopyApplication from "./CopyApplication/Index";
import EditEmail from "./EditEmail/EditEmail";
import EditMobile from "./EditMobile/EditMobile";
import EditStatus from "./EditStatus/EditStatus";
import KebabIcon from "../../../assets/svg/icons/common/kebab";
import ChevronRight16 from "../../../assets/svg/icons/common/ChevronRight16";
import ArchiveApp from "./ArchiveApp/ArchiveApp";
import ConfirmationModal from "./ConfirmationModal/ConfirmationModal";
import { cancelMultipleApp, deleteBulkApps } from "../../../../api";
import config from "../../../../config";
import toast from "react-hot-toast";
import useApplicationStore from "../../../stores/application";
import useCommonStore from "../../../stores/common";
import useUserStore from "../../../stores/user";
import AssignMSP from "./AssignMSP";
import EditZoho from "./EditZoho/EditZoho";
import AddPricingEquipmentModal from "../../../../components/modals/add-pricing-equipment-modal/add-pricing-equipment-modal";
import SubmitAdditionalDocuments from "./additional-document";
import useDomainStore from "../../../stores/domain";
import EditVarSheet from "./EditVarSheet";
import { isAppArchived } from "../../../utils/is-app-archived";
import { isAppRetentionExpired } from "../../../utils/is-app-retention-expired";

const MAIN_URL = config.paymentcloud.MAIN_URL;

function ApplicationRow({ app, fetchList, history }) {
  const { isKurvDomain } = useDomainStore();
  const [childAppOpen, setChildAppOpen] = useState(false);
  const [openAssignProcessor, setOpenAssignProcessor] = useState(false);
  const [showChangeOwner, setShowChangeOwner] = useState(false);
  const [confirmCopyApplication, setConfirmCopyApplication] = useState(false);
  const [openEditEmail, setOpenEditEmail] = useState(false);
  const [openArchiveApp, setOpenArchiveApp] = useState(false);
  const [openEditMobile, setOpenEditMobile] = useState(false);
  const [openEditStatus, setOpenEditStatus] = useState(false);
  const [openCancelConfirmation, setOpenCancelConfirmation] = useState(false);
  const [confirmAppDelete, setConfirmAppDelete] = useState(false);
  const [assignMspModal, setAssignMspModal] = useState(false);
  const [editZohoModal, setEditZohoModal] = useState(false);
  const [zohoIdType, setZohoIdType] = useState("zoho_id");
  const [openPAndEEditing, setOpenPAndEEditing] = useState(false);
  const [openAdditionalDocuments, setOpenAdditionalDocuments] = useState(false);
  const [openEditVARSheetModal, setOpenEditVARSheetModal] = useState(false);
  const loggedInUser = useUserStore((state) => state.user);
  const showDetails = useCommonStore((state) => state.showDetails);
  const setShowDetails = useCommonStore((state) => state.setShowDetails);
  const activeApp = useApplicationStore((state) => state.activeApp);
  const setActiveApp = useApplicationStore((state) => state.setActiveApp);
  const selectedApps = useApplicationStore((state) => state.selectedApps);
  const isPCAdmin = useUserStore((state) => state.isPCAdmin);
  const isAdmin = useUserStore((state) => state.isAdmin);
  const user = useUserStore((state) => state.user);
  const isKurvAdmin =
    user?.organization_id == config.paymentcloud.KURVPAY_ORG_ID &&
    user?.role == "admin";
  // Every endpoint behind the kebab refuses an application past the retention
  // window, so the menu is not offered at all rather than left to 403.
  const retentionExpired = isAppRetentionExpired(app);

  const updateSelectedApps = (event) => {
    const appId = +event.target.value;
    useApplicationStore.setState((prevState) => ({
      selectedApps: event.target.checked
        ? [...prevState.selectedApps, appId]
        : prevState.selectedApps.filter((id) => id !== appId),
    }));
  };

  const updateChildAppSelection = (event) => {
    const isChecked = event.target.checked;
    let ids = [+app.id];
    app.child.forEach((child) => {
      ids.push(+child.id);
    });

    useApplicationStore.setState((prevState) => ({
      selectedApps: isChecked
        ? [...new Set([...prevState.selectedApps, ...ids])]
        : prevState.selectedApps.filter((id) => !ids.includes(id)),
    }));
  };

  const editApplication = () => {
    if (isAppArchived(app?.created_at)) {
      setOpenArchiveApp(true);
      return;
    }
    if (app?.app_version == 2) {
      history.push(`/app/${app.user.agent_url}/${app.editslug}`);
    } else {
      let link = "";
      link = `${MAIN_URL}${app.user.agent_url}/${app.editslug}`;
      window.open(link);
    }
  };

  const handleEditZoho = (type) => {
    setZohoIdType(type);
    setEditZohoModal(true);
  };

  const copyApplicationURL = () => {
    let url = "";
    if (app?.app_version == 2) {
      url = `${window.location.origin}/app/${app.user.agent_url}/${app.editslug}`;
    } else {
      url = `${MAIN_URL}${app.user.agent_url}/${app.editslug}`;
    }
    navigator.clipboard.writeText(url);
    toast.success("Application URL copied to clipboard", {
      duration: 2000,
    });
  };

  const drop_down_options = [
    {
      text: "Copy Application URL",
      type: "normal",
      onClick: () => {
        copyApplicationURL();
      },
    },
    {
      text: "Assign Processor",
      type: "normal",
      onClick: () => {
        setOpenAssignProcessor(true);
      },
    },
    {
      text: "Assign MSP",
      type: "normal",
      onClick: () => {
        setAssignMspModal(true);
      },
    },
    {
      text: "Change owner",
      type: "normal",
      onClick: () => {
        setShowChangeOwner(true);
      },
      hidden: !isPCAdmin && !isKurvAdmin,
    },
    {
      text: "Duplicate Application",
      type: "normal",
      onClick: () => {
        setConfirmCopyApplication(true);
      },
    },
    {
      text: "Edit Zoho ID",
      type: "normal",
      onClick: () => {
        handleEditZoho("zoho_id");
      },
      hidden: !isPCAdmin,
    },
    {
      text: "Edit Submission ID",
      type: "normal",
      onClick: () => {
        handleEditZoho("submission_id");
      },
      hidden: !isPCAdmin,
    },
    {
      text: "Edit Application",
      type: "normal",
      onClick: () => {
        editApplication();
      },
      hidden: app?.editslug?.includes("Imported"),
    },
    {
      text: "Pricing and Equipment",
      type: "normal",
      hidden: !(
        (app?.organization_id == 1 &&
          app?.lead_progression_id > 3 &&
          app.lead_progression_id < 7) ||
        (app?.organization_id != 1 && app.lead_progression_id < 7)
      ),
      onClick: () => {
        if (isAppArchived(app?.created_at)) {
          setOpenArchiveApp(true);
          return;
        }
        if (app.app_version == 2) {
          history.push(`/v2/edit-pricing-equipment/${app.editslug}`);
        } else {
          setOpenPAndEEditing(true);
        }
      },
    },
    {
      text: "Edit OTP Email",
      type: "normal",
      onClick: () => {
        setOpenEditEmail(true);
      },
    },
    {
      text: "Edit OTP Mobile",
      type: "normal",
      onClick: () => {
        setOpenEditMobile(true);
      },
    },
    {
      text: "Submit Additional Documents",
      type: "normal",
      onClick: () => {
        setOpenAdditionalDocuments(true);
      },
      hidden: app?.lead_progression_id < 8,
    },
    {
      text: "Edit Status",
      type: "normal",
      onClick: () => {
        setOpenEditStatus(true);
      },
      hidden: !isPCAdmin,
    },
    {
      text: "Edit VAR Sheet",
      type: "normal",
      onClick: () => {
        setOpenEditVARSheetModal(true);
      },
      hidden: false,
    },
    {
      text: "Cancel",
      type: "danger",
      onClick: () => {
        setOpenCancelConfirmation(true);
      },
    },
    {
      text: "Delete",
      type: "danger",
      onClick: () => {
        setConfirmAppDelete(true);
      },
      hidden: !isPCAdmin,
    },
  ];

  const cancelApplication = async () => {
    const toastID = toast.loading("Cancelling apps...");
    const response = await cancelMultipleApp({ ids: [app?.id] });
    if (response.status) {
      toast.success("Apps cancelled successfully", { id: toastID });
      setOpenCancelConfirmation(false);
      fetchList();
    } else {
      toast.error("Something went wrong", { id: toastID });
    }
  };

  const deleteApplication = async () => {
    const toastID = toast.loading("Deleting apps...");
    const response = await deleteBulkApps({ bulkDeleteIds: [app?.id] });
    if (response.status) {
      toast.success("Apps deleted successfully", { id: toastID });
      fetchList();
      setConfirmAppDelete(false);
    } else {
      toast.error("Something went wrong", { id: toastID });
    }
  };

  return (
    <>
      <tr
        className={`${activeApp?.id == app.id ? style.active_app : ""} ${isKurvDomain ? style.kurv_theme : ""}`}
        // onClick={() => {
        //   setActiveApp(app);
        //   setShowDetails(true);
        // }}
      >
        <td>
          <Checkbox
            value={app.id}
            onChange={(event) => {
              if (app.child.length > 0) {
                updateChildAppSelection(event);
              } else {
                updateSelectedApps(event);
              }
            }}
            checked={
              app.child.length > 0
                ? app.child.every((child) => selectedApps.includes(child.id)) &&
                  selectedApps.includes(app.id)
                : selectedApps.includes(app.id)
            }
          />
          {app?.child?.length > 0 && (
            <ButtonIcon
              onClick={() => setChildAppOpen(!childAppOpen)}
              bgColor={"transparent"}
            >
              <div
                className={`${style.caret_icon} ${childAppOpen ? style.rotate_90 : ""}`}
              >
                <ChevronRight16 />
              </div>
            </ButtonIcon>
          )}
        </td>
        <td
          onClick={() => {
            setActiveApp(app);
            setShowDetails(true);
          }}
        >
          {app.field_dba}
        </td>
        <td
          onClick={() => {
            setActiveApp(app);
            setShowDetails(true);
          }}
        >
          <div className="status">
            <AppStatusDot
              progression_id={app?.lead_progression_id}
              hasChild={app.child.length > 0}
            />
            {app.child.length > 0 &&
              app.child.map((app, index) => (
                <AppStatusDot
                  key={index}
                  progression_id={app?.lead_progression_id}
                  hasChild={true}
                />
              ))}
          </div>
        </td>
        {!showDetails && (
          <td
            onClick={() => {
              setActiveApp(app);
              setShowDetails(true);
            }}
          >
            {app.id}
          </td>
        )}
        {(isPCAdmin || isAdmin) && (
          <td
            onClick={() => {
              setActiveApp(app);
              setShowDetails(true);
            }}
          >
            {isPCAdmin
              ? app?.organization?.name
              : isAdmin
                ? app?.user?.name || "-"
                : ""}
          </td>
        )}

        {!showDetails && (
          <>
            <td>{app?.created_at ? dateFormatter(app?.created_at) : ""}</td>
          </>
        )}
        {/* TODO: Add alerts column will do later */}
        {/* <td>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <circle cx="8" cy="8" r="7" fill="#E03B24" fillOpacity="0.2" />
            <circle cx="8" cy="8" r="3" fill="#E03B24" />
          </svg>
        </td> */}
        {!showDetails && (
          <td>
            {!retentionExpired && (
              <DropDown options={drop_down_options}>
                <KebabIcon />
              </DropDown>
            )}
          </td>
        )}
      </tr>
      {childAppOpen && (
        <ChildRow
          children={app.child}
          organization={app?.organization?.name}
          app={app}
        />
      )}

      {/* Actions */}
      {/* Assign processor */}
      {openAssignProcessor && (
        <AssignProcessor
          open={openAssignProcessor}
          onClose={() => setOpenAssignProcessor(false)}
          app={app}
        />
      )}
      {/* Change owner */}
      {showChangeOwner && (
        <ChangeOwner
          open={showChangeOwner}
          onClose={() => setShowChangeOwner(false)}
          app={app}
          fetchApplication={fetchList}
        />
      )}
      {/* Duplicate confirmation */}
      {confirmCopyApplication && (
        <CopyApplication
          isOpen={confirmCopyApplication}
          onClose={() => setConfirmCopyApplication(false)}
          appData={app}
          loggedInUser={loggedInUser}
          fetchApplication={fetchList}
          history={history}
        />
      )}
      {/* Edit email */}
      {openEditEmail && (
        <EditEmail
          open={openEditEmail}
          onClose={() => setOpenEditEmail(false)}
          appData={app}
          fetchApplication={fetchList}
        />
      )}
      {/* Edit mobile */}
      {openEditMobile && (
        <EditMobile
          open={openEditMobile}
          onClose={() => setOpenEditMobile(false)}
          appData={app}
          fetchApplication={fetchList}
        />
      )}
      {/* Edit status */}
      {openEditStatus && (
        <EditStatus
          open={openEditStatus}
          onClose={() => setOpenEditStatus(false)}
          appData={app}
          fetchApplication={fetchList}
        />
      )}
      {/* Edit Application Archive popup */}
      {openArchiveApp && (
        <ArchiveApp
          open={openArchiveApp}
          onClose={() => setOpenArchiveApp(false)}
          onDuplicate={() => {
            setOpenArchiveApp(false);
            setConfirmCopyApplication(true);
          }}
        />
      )}
      {/* Cancel confirmation */}
      {openCancelConfirmation && (
        <ConfirmationModal
          open={openCancelConfirmation}
          onClose={() => setOpenCancelConfirmation(false)}
          message={
            "Are you sure you want to cancel this app? You can't undo this action."
          }
          onConfirmClick={() => cancelApplication()}
        />
      )}
      {/* delete confirmation */}
      {confirmAppDelete && (
        <ConfirmationModal
          open={confirmAppDelete}
          onClose={() => setConfirmAppDelete(false)}
          message={
            "Are you sure you want to Delete this app? You can't undo this action."
          }
          onConfirmClick={() => deleteApplication()}
        />
      )}
      {/* Assign MSP */}
      {assignMspModal && (
        <AssignMSP
          open={assignMspModal}
          onClose={() => setAssignMspModal(false)}
          appData={app}
          onSuccess={fetchList}
        />
      )}
      {/* Edit Zoho ID */}
      {editZohoModal && (
        <EditZoho
          open={editZohoModal}
          onClose={() => setEditZohoModal(false)}
          appData={app}
          getAppData={fetchList}
          zohoIdType={zohoIdType}
        />
      )}
      {/* P&E Editing */}
      {openPAndEEditing && (
        <AddPricingEquipmentModal
          user={loggedInUser}
          slug={app.editslug}
          appId={app.id}
          isOpen={openPAndEEditing}
          close={() => setOpenPAndEEditing(false)}
        />
      )}
      {/* Submit Additional Documents to EMS */}
      {openAdditionalDocuments && (
        <SubmitAdditionalDocuments
          open={openAdditionalDocuments}
          onClose={() => setOpenAdditionalDocuments(false)}
          appData={app}
        />
      )}
      {/* Edit VAR Sheet */}
      {openEditVARSheetModal && (
        <EditVarSheet
          isOpen={openEditVARSheetModal}
          onClose={() => setOpenEditVARSheetModal(false)}
          powerapp_id={app.id}
        />
      )}
    </>
  );
}

export default withRouter(ApplicationRow);
